<!--
 * @Author: zyb
 * @Date: 2022-03-22 19:04:12
 * @LastEditors: wyj
 * @LastEditTime: 2022-05-05 10:01:55
 * @FilePath: \dev_2.0\src\views\home\index.vue
 * @Description: 
-->
<template>
  <div class="home">
    <home-swiper
      :screenWidth="screenWidth"
      :swiperList="screenWidth > 767 ? pcSwiperList : mbSwiperList"
    ></home-swiper>
    <Layout-main
      :goodsList="goodsList"
      :screenWidth="screenWidth"
    ></Layout-main>
  </div>
</template>
<script>
import HomeSwiper from "./childComp/HomeSwiper/HomeSwiper";
import LayoutMain from "./childComp/Layout-main";

export default {
  props: ["screenWidth"],
  data() {
    return {
      pcSwiperList: [
        // {
        //   pic: require("@/assets/images/home/homeSwiper3.jpg"),
        //   path: "product/blackboard",
        // },
        // //  {
        // //   pic: require("@/assets/images/home/homeSwiper4.jpg"),
        // //   path:'product/blackboard'
        // // },
        // {
        //   pic: require("@/assets/images/home/homeSwiper1.jpg"),
        //   path: "product/blackboard",
        // },
        // {
        //   pic: require("@/assets/images/home/homeSwiper2.jpg"),
        //   path: "product/machine",
        // },
      ],
      mbSwiperList: [
        // { pic: require("@/assets/images/home/swiperM1.jpg") },
        // { pic: require("@/assets/images/home/swiperM2.jpg") },
      ],
      goodsList: [
        { img: require("@/assets/images/home/homePei1.png"), name: "OPS" },
        {
          img: require("@/assets/images/home/homePei2.png"),
          name: "无线高拍仪",
        },
        { img: require("@/assets/images/home/homePei3.png"), name: "壁挂展台" },
        {
          img: require("@/assets/images/home/homePei4.png"),
          name: "空气净化器",
        },
      ],
    };
  },
  components: {
    HomeSwiper,
    LayoutMain,
  },
  created() {
    this.getBannerLists();
  },
  mounted() {},
  methods: {
    /**
     * @description: banner
     * @param {*}
     * @return {*}
     */
    async getBannerLists() {
      let list = await this.$store.dispatch("getBannerList");
      list.forEach((element) => {
        this.pcSwiperList.push({
          pic: element.photoPath,
          path: element.skipUrl,
        });
        this.mbSwiperList.push({
          pic: element.appPath,
          path: element.skipUrl,
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>